import { AliasDetail, EntityTypeEnum, ReferenceDataManagementEvent, TradingEntityMeta, WorkflowActions, WorkflowDetail } from 'api'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { workflowTradingEntityMetaGetterSelector } from 'selectors/workflowSelectors'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { TradingEntityAliasesPanelDialog } from './TradingEntityAliasesPanelDialog'

interface TradingEntityAliasesActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<WorkflowDetail<AliasDetail>> {
  workflowId: string
  context: {
    workflowId: string
    tradingEntityId: string
  }
}

export const TradingEntityAliasesPanelActionsButton = withModal((props: TradingEntityAliasesActionsButtonProps) => {
  const {
    context: { tradingEntityId, workflowId }
  } = props
  const dispatch = useDispatch()
  const getWorkflowMeta = useSelector(workflowTradingEntityMetaGetterSelector)

  function onEdit() {
    const [aliasDetail] = props.items

    props.showModal(
      <TradingEntityAliasesPanelDialog
        workflowInfo={{ workflowId, metaId: aliasDetail.metaId, index: aliasDetail.index }}
        ownerTradingEntityId={tradingEntityId}
      />
    )
  }

  function onDelete() {
    const [aliasDetail] = props.items

    const meta = getWorkflowMeta(workflowId, aliasDetail.metaId)

    if (meta) {
      dispatch(
        WorkflowActions.createEntityUpdateReferenceData<TradingEntityMeta>({
          entityId: aliasDetail.metaId,
          entityType: EntityTypeEnum.TRADING_ENTITY_META,
          updatedEntity: {
            ...meta,
            aliasTypeAndValues: meta.aliasTypeAndValues.filter((_, i) => {
              return i !== aliasDetail.index
            })
          },
          workflowId
        })
      )
    }
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: onEdit,
      enabled: props.items.length === 1 && props.items.every(i => i.availableEvents.includes(ReferenceDataManagementEvent.ENTITY_UPDATE))
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE),
      onClick: onDelete,
      enabled: props.items.every(i => i.availableEvents.includes(ReferenceDataManagementEvent.ENTITY_UPDATE))
    }
  ]

  return <SplitButtonDropdown dataTestId={'TradingEntityAliasesPanel-Edit-Button'} actions={actions} maxButtons={1} />
})
